@if (!isLoading()) {
  @if (isError()) {
    <infl-standard-page-error
      [errorTitle]="errorTitle()"
      [errorText]="errorText()"
      (actionClick)="onErrorClick($event)"
    />
  } @else {
    <div class="toolbar">
      <inf-actions-bar
        [config]="ActionsBarConfig.getClassicDarkStyle()"
        [title]="displayedTitle()"
        [icon]="icon()"
      />
    </div>
    <div class="tab-container">
      <infl-standard-page-tab-container
        [CRUD]="CRUD"
        [factory]="factory"
        [model]="model()"
        [displayDetails]="displayDetails"
      />
    </div>
  }
}
